module.exports = __webpack_public_path__ + "img/e_3_27_r.b5efeba7.png";